/**
 * @author PoornaChandu
 * @description updated code
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { StyledComponent } from './CSS/style';
import Highlighter from 'react-highlight-words';
import { getList, deleteById } from './Utils/FormCalls';
import localStorage from '../../../utils/localStorage';
import { API_BACKUP } from '../../../commons/api';
import {
  Button,
  Input,
  message,
  Modal
} from 'antd';
import StyledTable from '../../../commons/styles/table';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';

const APIList = {
  getList: `${API_BACKUP.PurgeGet}`,
  deleteData: `${API_BACKUP.PurgeDelete}`
};

const PurgeList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [userProfile,setUserProfile] = useState(props.userProfile);
  const [translationCache,setTranslationCache] = useState(props.translationCache);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? response : []);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.translationCache !== translationCache
    ) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }  }, [userProfile, translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
        {/* <Button
          type="link"
          
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
            this.setState({
              searchText: selectedKeys[0],
              searchedColumn: dataIndex,
            });
          }}
        >
          Filter
        </Button> */}
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };

  const _deleteById = async () => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      url: `${APIList.deleteData}?Id=${selectedRecord.TaskId}&SiteId=${siteId}&TableName=${selectedRecord.TableName}`,
      method: 'DELETE'
    };
    const response = await deleteById(payload);
    message.success(response && response.message);
    setDeleteModal(false);

    const updatedDataSource = await getList(APIList.getList);
    setDataSource(updatedDataSource);
  };

  const columns = [
    {
      title: translation('Table Name'),
      dataIndex: 'TableName',
      key: 'TableName',
      ...getColumnSearchProps('TableName')
    },
    {
      title: translation('Task Name'),
      dataIndex: 'TaskName',
      key: 'TaskName',
      ...getColumnSearchProps('TaskName')
    },
    {
      title: translation('Start Time'),
      key: 'StartDate',
      dataIndex: 'StartDate',
      ...getColumnSearchProps('StartDate'),
      sorter: (a, b) => new Date(a.StartDate) - new Date(b.StartDate),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      )
    },
    {
      title: translation('End Time'),
      key: 'EndDate',
      dataIndex: 'EndDate',
      ...getColumnSearchProps('EndDate'),
      sorter: (a, b) => new Date(a.EndDate) - new Date(b.EndDate),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      )
    },
    {
      title: translation('Purge Data'),
      width: '600',
      render: (text, record) => (
        <Button
          disabled={record && record.DeleteStatus === 'Yet to Start' ? false : true}
          style={{ marginRight: '5px' }}
          className="ant-btn"
          onClick={() => {
            setDeleteModal(true);
            setSelectedRecord(record);
          }}
          
        >
          <DeleteOutlined />
        </Button>
      )
    }
  ];

  return (
    <>
      <StyledComponent
        theme={themeSettings}
        style={{
          minHeight: window.innerHeight - 143,
          margin: '5px'
        }}
      >
        <div style={{ color: 'white', margin: '20px 20px'}}>
          {translation('Purge')}
        </div>
        <div style={{ marginTop: '40px' }}>
          <StyledTable size="small"
            dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
            columns={columns}
          />
        </div>
        <Modal
          width="50%"
          title={translation('Confirm the Action')}
          open={deleteModal}
          onCancel={() => setDeleteModal(false)}
          closable
          theme={themeSettings}
          footer={[
            <Button
              key="back"
              onClick={() => setDeleteModal(false)}
            >
              {translation('Cancel')}
            </Button>,
            <Button
              key="Submit"
              type="primary"
              className="confirmButton"
              onClick={_deleteById}
            >
              {translation('Confirm')}
            </Button>
          ]}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', width: '1300px' }}>
            <p>Do you really want to purge the selected data from the database?</p>
          </div>
        </Modal>
      </StyledComponent>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(PurgeList);